import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: () => ({
        email: null,
        firstname: null,
        avatar: null
    }),
    getters: {
        account: state => {
            return state
        }
    },
    mutations: {
        set (state, payload) {
            for (const k in payload) {
                if (!Object.prototype.hasOwnProperty.call(payload, k)) continue
                Vue.set(state, k, payload[k]) // This allows us to add new data on the fly
            }
        }
    },
    actions: {
        async load ({ commit }) {
            if (Vue.storage.get('sessionId', null)) {
                return new Promise((resolve, reject) => {
                    Vue.http.get('account/').then(
                        response => {
                            commit('set', response.body.account)
                            resolve(response.body)
                        },
                        response => {
                            reject(response)
                        }
                    )
                })
            }
        },
        async connect (store, token) {
            Vue.storage.set('sessionId', token)
        }
    }
})

export default store
